import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactDOM from 'react-dom'
import { withRouter } from 'react-router'

import { 
    postSearch, 
    createOrReturnChat,
    openModal
} from 'state/actions'

import {
    getApplicableProjects,
} from 'state/selectors'

import HeaderSearchResults from './header-search-results'
import HeaderTimer from './header-timer'

import { debounce } from 'lodash'

import { 
    doClickEventListeners,
    isMobile
} from 'utils'

import { MainContext } from 'context'

class HeaderSearch extends Component {
    constructor(props) {
        super(props)

        this.state = {
            searchResults: [],
            searchTerm: '',
            resultsHeight: 0
        }

        this.clickOutsideRef = null
        this.debouncedDoSearch = debounce(this.handleDebouncedSearch, 500)
    }

    componentWillMount() {
        doClickEventListeners(this.handleClickOutside)
    }

    componentWillUnmount() {
        doClickEventListeners(this.handleClickOutside, true)
    }

    handleClickOutside = (e = null) => {
        if (!this.clickOutsideRef) {
            return
        }

        if (!e || !this.clickOutsideRef.contains(e.target) && this.state.resultsHeight) {
            this.setState({
                resultsHeight: 0
            })
        }
    }

    filterSearchResultsByApplicableProjects = results => {
        const {
            applicableProjects,
            allEntities
        } = this.props

        const applicableProjectIds = applicableProjects ? Object.keys(applicableProjects) : []

        const response = {}

        if(results){
            Object.keys(results).forEach(key => {
                const entities = results[key]

                let filterResult = []

                switch(key){
                    case 'files':
                    case 'notes':
                    case 'milestones':
                    case 'tasks':
                        filterResult = entities.filter(entity => ~applicableProjectIds.indexOf(''+entity.project_id))
                        break
                    case 'projects':
                        filterResult = entities.filter(entity => ~applicableProjectIds.indexOf(''+entity.id))
                        break
                    case 'comments':
                        filterResult = entities.filter(entity => {
                            const task = allEntities.tasks[entity.task_id]

                            if(task){
                                return ~applicableProjectIds.indexOf(''+task.project_id)
                            }
                            
                        })
                        break
                }

                response[key] = filterResult
            })
        }

        return response
    }

    handleDebouncedSearch = searchTerm => {
        const {
            postSearch,
            currentAccount,
        } = this.props

        postSearch(searchTerm, currentAccount, searchResults => {
            const currentSearchTerm = this.state.searchTerm

            if(currentSearchTerm == searchTerm){
                const filteredSearchResults = this.filterSearchResultsByApplicableProjects(searchResults)

                this.setState({
                    searchResults: filteredSearchResults,
                    isLoading: false
                }, _ => {
                    window.requestAnimationFrame(_ => {
                        this.calculateResultsHeight()
                    })
                })
            }
        })
    }

    doSearch = e => {
        this.setState({
            searchTerm: e.target.value,
            searchResults: []
        })

        const searchTerm = e.target.value

        if (searchTerm.length > 2) {
            this.setState({
                isLoading: true
            })
            
            this.debouncedDoSearch(searchTerm)
        }

        setTimeout(_ => {
            this.calculateResultsHeight()
        }, 1)
    }

    calculateResultsHeight = _ => {
        if (this.ref) {
            let newHeight = ReactDOM.findDOMNode(this.ref).getBoundingClientRect().height

            this.setState({
                resultsHeight: newHeight
            })
        }
    }

    openUpgradeModal = _ => {
        const {
            openModal
        } = this.props

        openModal('pricing','pricing')
    }

    render() {
        const {
            searchResults,
            resultsHeight,
            isLoading,
            searchTerm
        } = this.state

        const {
            width,
            allEntities,
            match,
            history,
            createOrReturnChat
        } = this.props

        const {
            account
        } = this.context

        return (
            <div
                style={{ width }}
                className="header-search"
                ref={e => this.clickOutsideRef = e}
            >
                <input
                    onClick={this.calculateResultsHeight}
                    value={searchTerm}
                    onChange={this.doSearch}
                    placeholder="Search everything..."
                    type="text"
                />
                <div
                    style={{ height: resultsHeight + 'px' }}
                    className="search-results-list-container"
                >
                    <div ref={e => this.ref = e}>
                        {
                            searchTerm ?
                                <HeaderSearchResults
                                    createOrReturnChat={createOrReturnChat}
                                    dismissResults={this.handleClickOutside}
                                    history={history}
                                    match={match}
                                    allEntities={allEntities}
                                    isLoading={isLoading}
                                    searchTerm={searchTerm}
                                    searchResults={searchResults}
                                    calculateResultsHeight={this.calculateResultsHeight}
                                    resultsHeight={resultsHeight}
                                />
                                : null
                        }
                    </div>
                </div>
                { !isMobile() ?
                <React.Fragment>
                    {account.isPremium ?
                        <HeaderTimer />
                        : null
                    }
                </React.Fragment>
                : null }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
		allEntities: state.account.entities,
        applicableProjects: getApplicableProjects(state),
    }
}

export default withRouter(connect(mapStateToProps, { 
    postSearch, 
    createOrReturnChat,
    openModal
})(HeaderSearch))

HeaderSearch.contextType = MainContext


// WEBPACK FOOTER //
// ./src/layout/header/header-search.jsx